import { FC } from "react";
import { Stack } from "@mui/material";
import { InfrastructureArchitectureHierarchy } from "./hierarchy/InfrastructureArchitectureHierarchy";
import { InfrastructureArchitectureAccountSelect } from "@/components/pages/infrastructure-architecture/components/select-panel/body/InfrastructureArchitectureAccountSelect";
import { InfrastructureArchitectureRegionSelect } from "@/components/pages/infrastructure-architecture/components/select-panel/body/region-select/InfrastructureArchitectureRegionSelect";
import { InfrastructureArchitectureServiceSelect } from "@/components/pages/infrastructure-architecture/components/select-panel/body/service-select/InfrastructureArchitectureServiceSelect";
import { InfrastructureArchitectureGenerateDiagramButton } from "@/components/pages/infrastructure-architecture/components/select-panel/body/InfrastructureArchitectureGenerateDiagramButton";

export const InfrastructureArchitectureSelectPanelBody: FC = () => {
  return (
    <Stack spacing={1.5} p={2} overflow="auto">
      <InfrastructureArchitectureAccountSelect />
      <InfrastructureArchitectureRegionSelect />
      <InfrastructureArchitectureServiceSelect />
      <InfrastructureArchitectureGenerateDiagramButton />

      <InfrastructureArchitectureHierarchy />
    </Stack>
  );
};
